'use client';

import React from 'react';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="flex items-center gap-1.5 text-xs font-semibold text-brand-text-muted select-none flex-wrap">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {item.href && !isLast ? (
              <Link
                href={item.href}
                className="hover:text-brand-text-dark transition-colors duration-150 py-1"
              >
                {item.label}
              </Link>
            ) : item.onClick && !isLast ? (
              <button
                onClick={item.onClick}
                className="hover:text-brand-text-dark transition-colors duration-150 py-1 focus:outline-none font-semibold text-xs"
              >
                {item.label}
              </button>
            ) : (
              <span className={`py-1 ${isLast ? 'text-brand-text-dark font-black' : ''}`}>
                {item.label}
              </span>
            )}
            {!isLast && <ChevronRight size={14} className="text-brand-border-dark shrink-0" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
